module.exports = __webpack_public_path__ + "img/horizontal-rule.42f84d4e.svg";